export default __webpack_public_path__ + "static/media/uio.9220f0d1.png";